import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex justify-end visible lg:hidden" }
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = { class: "sm:flex flex-row w-full items-center" }
const _hoisted_4 = { class: "flex flex-col lg:flex-row w-full lg:w-1/3 items-center" }
const _hoisted_5 = { class: "flex flex-col lg:ml-3 lg:justify-start justify-center items-center lg:items-start w-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-30 pr-1" }, "(Draft)", -1)
const _hoisted_7 = { class: "flex flex-row space-x-3 items-center text-gray-400 w-full lg:truncate text-center lg:text-start justify-center lg:justify-start" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_9 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "/", -1)
const _hoisted_11 = { class: "text-xs text-gray-400 truncate" }
const _hoisted_12 = { class: "flex flex-row space-x-2 items-center text-xs text-gray-400 capitalize lg:justify-start justify-center w-full lg:items-start" }
const _hoisted_13 = { class: "lg:truncate" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "·", -1)
const _hoisted_15 = {
  key: 0,
  class: "truncate lg:w-52"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "flex flex-row items-start space-x-1 mt-1" }
const _hoisted_18 = {
  key: 0,
  class: "text-xs rounded-lg font-light bg-primary-light py-1 px-3 text-primary flex flex-row justify-between items-center"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-4 w-4 text-purple-700 mr-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "3",
    d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Managed")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "text-xs rounded-lg font-light bg-primary-light py-1 px-3 text-primary flex flex-row justify-between items-center"
}
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-4 w-4 text-purple-700 mr-2\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"2\" ry=\"2\"></rect><rect x=\"9\" y=\"9\" width=\"6\" height=\"6\"></rect><line x1=\"9\" y1=\"1\" x2=\"9\" y2=\"4\"></line><line x1=\"15\" y1=\"1\" x2=\"15\" y2=\"4\"></line><line x1=\"9\" y1=\"20\" x2=\"9\" y2=\"23\"></line><line x1=\"15\" y1=\"20\" x2=\"15\" y2=\"23\"></line><line x1=\"20\" y1=\"9\" x2=\"23\" y2=\"9\"></line><line x1=\"20\" y1=\"14\" x2=\"23\" y2=\"14\"></line><line x1=\"1\" y1=\"9\" x2=\"4\" y2=\"9\"></line><line x1=\"1\" y1=\"14\" x2=\"4\" y2=\"14\"></line></svg> AI Match", 2)
const _hoisted_25 = [
  _hoisted_23
]
const _hoisted_26 = { class: "flex flex-col lg:flex-row items-center w-full lg:w-1/3 lg:items-start justify-center mt-2 lg:mt-0" }
const _hoisted_27 = { class: "flex flex-col justify-center items-center" }
const _hoisted_28 = {
  key: 0,
  class: "bg-yellow-300 text-yellow-800 px-2 py-1 rounded-lg opacity-50 text-xs text-center"
}
const _hoisted_29 = {
  key: 1,
  class: "bg-green-100 text-green-900 font-normal px-2 py-1 rounded-lg opacity-50 text-xs text-center"
}
const _hoisted_30 = { class: "flex flex-row items-center space-x-2 mt-2" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-4 w-4 text-gray-400\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2\"></path></svg><div class=\"block mx-asuto h-8 bg-gray-100 text-center p-2 rounded text-xs text-gray-400\"> - </div><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-4 w-4 text-gray-400\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z\"></path></svg>", 3)
const _hoisted_34 = { class: "block mx-asuto h-8 bg-gray-100 text-center p-2 rounded text-xs text-gray-400" }
const _hoisted_35 = { class: "ml-6 flex flex-row space-x-2 lg:space-x-0 lg:flex-col lg:items-end" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "flex text-xs text-gray-400 items-center capitalize" }, "Last interaction: ", -1)
const _hoisted_37 = { class: "flex text-xs text-gray-400 items-center capitalize" }
const _hoisted_38 = { class: "flex flex-col lg:flex-row w-full lg:w-1/3 lg:items-start items-center justify-center lg:space-y-0 space-y-3 lg:justify-between" }
const _hoisted_39 = { class: "flex flex-col justify-center items-center text-center" }
const _hoisted_40 = {
  key: 0,
  class: "w-full flex flex-col justify-center items-center mt-2 lg:mt-0 md:mt-0"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex w-full flex-row items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-1 h-1 rounded-full bg-green-500" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-xs ml-1" }, "Assigned to")
  ])
], -1)
const _hoisted_42 = { class: "text-xs text-gray-400 text-left" }
const _hoisted_43 = { class: "" }
const _hoisted_44 = {
  key: 0,
  class: ""
}
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" in ")
const _hoisted_46 = { class: "" }
const _hoisted_47 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_48 = { class: "flex flex-col space-y-1" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
  })
], -1)
const _hoisted_50 = { class: "lg:justify-end flex flex-row justify-center mt-2 lg:mt-0" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  })
], -1)
const _hoisted_52 = { class: "hidden lg:flex lg:visible" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = {
  key: 0,
  class: "block"
}
const _hoisted_57 = { class: "w-full pb-2" }
const _hoisted_58 = { class: "text-gray-800 text-sm" }
const _hoisted_59 = { class: "hidden sm:flex flex-row justify-around w-full items-center" }
const _hoisted_60 = { class: "space-y-2 justify-items-center grid opacity-40" }
const _hoisted_61 = { class: "text-center flex justify-start items-center 2xl:text-xs sm:text-xxs" }
const _hoisted_62 = {
  key: 0,
  class: "p-4"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-300",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = {
  key: 1,
  class: "p-4 text-gray-300 text-xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuJob = _resolveComponent("MenuJob")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Link = _resolveComponent("Link")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass([[
      { 'bg-white border border-gray-400': _ctx.activeItem === index },
      item.workable_id ? 'bg-white' : 'bg-gray-100',
    ], "shadow rounded-2xl px-4 py-5 my-5 justify-between items-center w-full h-full border hover:border-gray-600"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_MenuJob, {
          jobId: item.id,
          hasChallenge: item.has_challenge_assigned,
          showAssing: _ctx.showAssing,
          hasEvaluation: item.has_evaluation,
          hasRecruiter: item.responsible_recruiter ? true : false,
          onOpenTemplate: ($event: any) => (_ctx.openTemplate(item.id)),
          onOpenEvaluation: ($event: any) => (_ctx.openTemplate(item.id)),
          onOpenChallenge: ($event: any) => (_ctx.openChallenge(item.id)),
          onDeactivateJob: ($event: any) => (_ctx.deactivateJob(item)),
          onAssignJob: ($event: any) => (_ctx.assignJob(item)),
          isClosedJob: item.is_closed
        }, null, 8, ["jobId", "hasChallenge", "showAssing", "hasEvaluation", "hasRecruiter", "onOpenTemplate", "onOpenEvaluation", "onOpenChallenge", "onDeactivateJob", "onAssignJob", "isClosedJob"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Avatar, {
              name: item && item.company && item.company?.visible_name,
              size: "s",
              color: item.workable_id ? 'bg-primary' : 'bg-gray-400'
            }, null, 8, ["name", "color"]),
            _createElementVNode("div", _hoisted_5, [
              (item.job_status !== 'draft')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: `/jobs/${item.id}/details`,
                    class: "font-bold hover:underline truncate lg:w-64"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: `/edit-job/${item.id}`,
                    class: "font-bold hover:underline truncate w-64"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])),
              _createElementVNode("div", _hoisted_7, [
                (item?.salary_min && item?.salary_max)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.salaryRange(
                    item.salary_min,
                    item.salary_max,
                    item.currency_salary,
                    item.show_monthly_salary
                  )), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, "Define range salary")),
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(item?.company?.visible_name), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(item.department ? item.department : "Define department"), 1),
                _hoisted_14,
                (!item.is_remote)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(` ${
                    item.job_location?.location?.street_address
                      ? item.job_location?.location?.street_address
                      : "Define location"
                  }`), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_16, " Remote "))
              ]),
              _createElementVNode("div", _hoisted_17, [
                (item.is_managed)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _hoisted_21))
                  : _createCommentVNode("", true),
                (item.match_candidates)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _hoisted_25))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              (!item.workable_id)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Not synced "))
                : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(item.job_status.replace(/_/g, " ")), 1)),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_34, _toDisplayString(item?.number_candidates || "-"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.format(new Date(item.last_interaction), "PP")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              (item.responsible_recruiter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("span", _hoisted_43, _toDisplayString(item.responsible_recruiter.first_name) + " " + _toDisplayString(item.responsible_recruiter.last_name), 1),
                      (item.recruiter_assigned_date)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                            _hoisted_45,
                            _createVNode(_component_DateFormatter, {
                              date: item.recruiter_assigned_date
                            }, null, 8, ["date"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_Button, {
                      class: _normalizeClass([!item.has_evaluation ? 'visible' : 'hidden']),
                      variant: "outlined",
                      label: "Add evaluation",
                      labelSize: "text-xs",
                      onOnClick: ($event: any) => (_ctx.openTemplate(item.id))
                    }, {
                      startIcon: _withCtx(() => [
                        _hoisted_49
                      ]),
                      _: 2
                    }, 1032, ["class", "onOnClick"])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_Link, {
                      labelSize: "text-xs",
                      variant: "",
                      label: "Add candidates",
                      route: `/jobs/${item.id}&openModal=true`
                    }, {
                      startIcon: _withCtx(() => [
                        _hoisted_51
                      ]),
                      _: 2
                    }, 1032, ["route"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createVNode(_component_MenuJob, {
                jobId: item.id,
                hasChallenge: item.has_challenge_assigned,
                showAssing: _ctx.showAssing,
                hasEvaluation: item.has_evaluation,
                hasRecruiter: item.responsible_recruiter ? true : false,
                onOpenTemplate: ($event: any) => (_ctx.openTemplate(item.id)),
                onOpenEvaluation: ($event: any) => (_ctx.openTemplate(item.id)),
                onOpenChallenge: ($event: any) => (_ctx.openChallenge(item.id)),
                onDeactivateJob: ($event: any) => (_ctx.deactivateJob(item)),
                onAssignJob: ($event: any) => (_ctx.assignJob(item)),
                isClosedJob: item.is_closed
              }, null, 8, ["jobId", "hasChallenge", "showAssing", "hasEvaluation", "hasRecruiter", "onOpenTemplate", "onOpenEvaluation", "onOpenChallenge", "onDeactivateJob", "onAssignJob", "isClosedJob"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-row justify-center mt-4", index === _ctx.activeItem && 'py-1'])
      }, [
        _createElementVNode("button", {
          onClick: ($event: any) => (_ctx.expandCard(index)),
          class: "rounded hover:bg-gray-100"
        }, [
          (_openBlock(), _createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: _normalizeClass(["h-6 w-6 text-gray-400", _ctx.activeItem === index && 'transform rotate-180']),
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            "stroke-width": "2"
          }, _hoisted_55, 2))
        ], 8, _hoisted_53)
      ], 2),
      (index === _ctx.activeItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("span", _hoisted_58, _toDisplayString(item.description ? item.description : "No description assigned "), 1)
            ]),
            _createElementVNode("div", _hoisted_59, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.job_stages, (el, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: _normalizeClass(["flex items-center", [
            el.stage.name === 'Rejected' ? 'text-red-900' : 'text-gray-900',
          ]])
                }, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["block mx-auto text-xs h-8 text-center p-2 rounded", [
                el.stage.name === 'Rejected' ? 'bg-red-200' : 'bg-gray-200',
              ]])
                    }, _toDisplayString(el.number_candidates), 3),
                    _createElementVNode("span", _hoisted_61, _toDisplayString(el.stage.name), 1)
                  ]),
                  (
              i !== item.job_stages.length - 1 &&
              i !== item.job_stages.length - 2
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
                    : (i === item.job_stages.length - 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, " | "))
                      : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2))
  }), 128))
}